export default "__VITE_ASSET__DoES2qOL__"